function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg038Uruguay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.006 512.006",
    style: {
      enableBackground: "new 0 0 512.006 512.006"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 0.007,
    style: {
      fill: "#F0F0F0"
    },
    width: 511.999,
    height: 511.999
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    style: {
      fill: "#338AF3"
    },
    width: 511.999,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 128,
    style: {
      fill: "#338AF3"
    },
    width: 511.999,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 383.999,
    style: {
      fill: "#338AF3"
    },
    width: 511.999,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 255.999,
    style: {
      fill: "#338AF3"
    },
    width: 511.999,
    height: 64
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 0.004,
    style: {
      fill: "#F0F0F0"
    },
    width: 255.999,
    height: 255.999
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "197.568,128.002 169.143,141.373 184.28,168.902 153.414,162.997 149.503,194.178   128.003,171.245 106.504,194.178 102.593,162.997 71.728,168.901 86.863,141.372 58.438,128.002 86.864,114.632 71.728,87.103   102.592,93.007 106.505,61.827 128.003,84.759 149.504,61.827 153.414,93.007 184.281,87.103 169.144,114.632 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg038Uruguay);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMi4wMDYgNTEyLjAwNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyLjAwNiA1MTIuMDA2OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxyZWN0IHg9IjAuMDAzIiB5PSIwLjAwNyIgc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHdpZHRoPSI1MTEuOTk5IiBoZWlnaHQ9IjUxMS45OTkiLz4KPGc+Cgk8cmVjdCB4PSIwLjAwMyIgc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHdpZHRoPSI1MTEuOTk5IiBoZWlnaHQ9IjY0Ii8+Cgk8cmVjdCB4PSIwLjAwMyIgeT0iMTI4IiBzdHlsZT0iZmlsbDojMzM4QUYzOyIgd2lkdGg9IjUxMS45OTkiIGhlaWdodD0iNjQiLz4KCTxyZWN0IHg9IjAuMDAzIiB5PSIzODMuOTk5IiBzdHlsZT0iZmlsbDojMzM4QUYzOyIgd2lkdGg9IjUxMS45OTkiIGhlaWdodD0iNjQiLz4KCTxyZWN0IHg9IjAuMDAzIiB5PSIyNTUuOTk5IiBzdHlsZT0iZmlsbDojMzM4QUYzOyIgd2lkdGg9IjUxMS45OTkiIGhlaWdodD0iNjQiLz4KPC9nPgo8cmVjdCB4PSIwLjAwMyIgeT0iMC4wMDQiIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiB3aWR0aD0iMjU1Ljk5OSIgaGVpZ2h0PSIyNTUuOTk5Ii8+Cjxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBwb2ludHM9IjE5Ny41NjgsMTI4LjAwMiAxNjkuMTQzLDE0MS4zNzMgMTg0LjI4LDE2OC45MDIgMTUzLjQxNCwxNjIuOTk3IDE0OS41MDMsMTk0LjE3OCAgIDEyOC4wMDMsMTcxLjI0NSAxMDYuNTA0LDE5NC4xNzggMTAyLjU5MywxNjIuOTk3IDcxLjcyOCwxNjguOTAxIDg2Ljg2MywxNDEuMzcyIDU4LjQzOCwxMjguMDAyIDg2Ljg2NCwxMTQuNjMyIDcxLjcyOCw4Ny4xMDMgICAxMDIuNTkyLDkzLjAwNyAxMDYuNTA1LDYxLjgyNyAxMjguMDAzLDg0Ljc1OSAxNDkuNTA0LDYxLjgyNyAxNTMuNDE0LDkzLjAwNyAxODQuMjgxLDg3LjEwMyAxNjkuMTQ0LDExNC42MzIgIi8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };